import { Flex, Typography } from "antd";
import { useTranslation } from "react-i18next";
import welcomeIcon from '@/assets/images/system/welcome.png'
import { CustomWindow } from "@/types/common";

const { Title } = Typography;

const WelcomePage: React.FC = () => {  
  const { t } = useTranslation();

  return (
    <Flex vertical align='center' justify='center' style={{ width: '100%', height: '100%', marginTop: -50 }}>
      <img src={welcomeIcon} style={{ height: '40vh' }} alt="" />
      <Title>{t('login.welcome', { name: (window as unknown as CustomWindow).config.server_name })}</Title>
    </Flex>
  )
}  
  
export default WelcomePage;